import kassensystem from './kassensystem';
import reservierung from './reservierung';
import personal from './personal';
import order from './order';
import delivery from './delivery';
import loyalty from './loyalty';
import socialMedia from './socialMedia';
import website from './website';
import reporting from './reporting';
import warenwirtschaft from './warenwirtschaft';

export const INSIGHTS_TOPICS = [
  kassensystem,
  reservierung,
  personal,
  order,
  delivery,
  loyalty,
  socialMedia,
  website,
  reporting,
  warenwirtschaft,
];

export const getTopic = (slug) => INSIGHTS_TOPICS.find((t) => t.slug === slug);

export const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const blockText = (b) => {
  switch (b.type) {
    case 'p':
    case 'tip':
    case 'warn':
      return b.text;
    case 'list':
    case 'steps':
      return b.items.join(' ');
    case 'table':
      return [...b.head, ...b.rows.flat()].join(' ');
    case 'faq':
      return b.items.map((i) => `${i.q} ${i.a}`).join(' ');
    default:
      return '';
  }
};

export const wordCount = (article) => {
  const text = [article.intro || '', ...article.sections.flatMap((s) => [s.heading, ...s.blocks.map(blockText)])].join(' ');
  return text.split(/\s+/).filter(Boolean).length;
};

export const readingTime = (article) => Math.max(1, Math.round(wordCount(article) / 170));

export const totalArticles = () => INSIGHTS_TOPICS.reduce((n, t) => n + 1 + t.subArticles.length, 0);
